export default {
    SKIP_TUTORIAL: false,
    WORLD_DISABLE_ENEMIES: false,
    IMMORTAL: false,
    WORLD_ENABLE_COLLISION_DEBUG: false,
    PHASE: 1,
    APP: false
}